export default class StickyButtonsMobile {
  elements;

  constructor() {
    this.elements = {
      section: document.querySelector('.cart-sticky-buttons-mobile-section'),
      showAdditionalPaymentsButton: document.querySelector('[data-cart-sticky-buttons-mobile-show-additional]'),
      closeAdditionalPaymentsButton: document.querySelector('[data-cart-sticky-buttons-mobile-close-additional]'),
    };

    if (this.elements.showAdditionalPaymentsButton !== null) {
      this.elements.showAdditionalPaymentsButton.addEventListener('click', this.handleShowAdditionalPayments.bind(this));
    }

    if (this.elements.closeAdditionalPaymentsButton !== null) {
      this.elements.closeAdditionalPaymentsButton.addEventListener('click', this.handleCloseAdditionalPayments.bind(this));
    }
  }

  handleShowAdditionalPayments = (e) => {
    this.elements.section.classList.add('opened');

    // Hide the loader after 2 seconds
    // window.setTimeout(() => {
    //   this.elements.section.classList.add('loaded');
    // }, 2000);
  };

  handleCloseAdditionalPayments = (e) => {
    this.elements.section.classList.remove('opened');
  };
}
